import { useEffect, useState } from "react";

import themeConfig from "../../site/config/theme";

/*
  ============================================================
  PHOTOGRAPHY PREMIUM
  Theme hook
  ============================================================

  Teema tallennetaan selaimeen, mutta vain sellainen arvo
  hyväksytään, joka löytyy themeConfigista.

  Näin esimerkiksi vanha tai rikkinäinen localStorage-arvo
  ei voi hajottaa sivuston teemaa.
*/

function getAvailableThemes() {
  return Object.keys(themeConfig.themes);
}

function getInitialTheme() {
  const fallbackTheme = themeConfig.defaultTheme;
  const availableThemes = getAvailableThemes();

  if (typeof window === "undefined") {
    return fallbackTheme;
  }

  try {
    const storedTheme = window.localStorage.getItem(
      themeConfig.storageKey
    );

    if (storedTheme && availableThemes.includes(storedTheme)) {
      return storedTheme;
    }
  } catch {
    // Sivusto toimii normaalisti myös ilman localStoragea.
  }

  return fallbackTheme;
}

export default function useTheme() {
  const [theme, setThemeState] = useState(getInitialTheme);

  useEffect(() => {
    document.documentElement.dataset.theme = theme;

    try {
      window.localStorage.setItem(
        themeConfig.storageKey,
        theme
      );
    } catch {
      // Teeman vaihtaminen toimii myös ilman localStoragea.
    }
  }, [theme]);

  function setTheme(nextTheme) {
    const availableThemes = getAvailableThemes();

    if (!availableThemes.includes(nextTheme)) {
      return;
    }

    setThemeState(nextTheme);
  }

  function toggleTheme() {
    const availableThemes = getAvailableThemes();
    const currentIndex = availableThemes.indexOf(theme);

    const nextIndex =
      currentIndex === availableThemes.length - 1
        ? 0
        : currentIndex + 1;

    setTheme(availableThemes[nextIndex]);
  }

  return {
    theme,
    themes: themeConfig.themes,
    setTheme,
    toggleTheme,
  };
}
